

const onboardingPagesDesktop = {
  id: 'onboarding', label: 'On-Boarding', icon: 'lock',
  tabs: ['Policies', 'Doc-Hub', 'Training'],
};

const personalAccountDesktop = {
  id: 'personal', label: 'Personal', icon: 'users',
  tabs: ['Money', 'User Details', 'Password', 'Resignation'],
};

const accountEntryDesktop = {
  id: 'account', label: 'Account', icon: 'user',
  pages: [personalAccountDesktop, onboardingPagesDesktop],
};

const adminEntryDesktop = {
  id: 'admin', label: 'Admin', icon: 'user',
  pages: [personalAccountDesktop, onboardingPagesDesktop],
};

const accountMobile = {
  id: 'account',
  label: 'Account',
  icon: 'user',
  pages: [
    { id: 'personal-account', label: 'Personal',    icon: 'users', tabs: ['Money', 'User Details', 'Password'] },
    { id: 'onboarding-page',  label: 'On-Boarding', icon: 'lock',  tabs: ['Policies', 'Doc-Hub', 'Training'] },
  ],
};

// ────────────────────────────────────────────────
// Casual work — the two availability pages (routes in map.js navSections):
//   /superworkavailabilityd|m  "Casuals Work Responses"  every supervisor-tier section
//   /workavailabilityd|m       "Casuals Availability"    Staff, only for casuals (requires: 'casual')
// Tabs mirror FilterAvailablesuperd/m.jsx and FilterAvailablestaffd/m.jsx.
// ────────────────────────────────────────────────
const casualsResponsesDesktop = {
  id: 'casuals-responses', label: 'Casuals Work Responses', icon: 'calendar',
  pages: [
    { id: 'casual-jobs', label: 'Casual Jobs', icon: 'calendar', tabs: ['Create Jobs', 'Open Slots', 'Responses', 'Roster', 'Messages'] },
  ],
};

const casualsResponsesMobile = {
  id: 'casuals-responses', label: 'Casuals Work Responses', icon: 'calendar',
  pages: [
    { id: 'create-jobs-m', label: 'Create Jobs', icon: 'plus',     tabs: ['Jobs', 'Messages'] },
    { id: 'casual-jobs-m', label: 'Casual Jobs', icon: 'calendar', tabs: ['Slots', 'Replies', 'Roster'] },
  ],
};

const casualsAvailabilityDesktop = {
  id: 'casuals-availability', label: 'Casuals Availability', icon: 'calendar', requires: 'casual',
  pages: [
    { id: 'casual-availability', label: 'Casual Availability', icon: 'calendar', tabs: ['Create Availability', 'My Availability', 'Assigned Jobs', 'Jobs Completed', 'Messages'] },
  ],
};

const casualsAvailabilityMobile = {
  id: 'casuals-availability', label: 'Casuals Availability', icon: 'calendar', requires: 'casual',
  pages: [
    { id: 'availability-m', label: 'Availability', icon: 'calendar', tabs: ['Create', 'Mine'] },
    { id: 'jobs-m',         label: 'Jobs',         icon: 'users',    tabs: ['Jobs', 'Done', 'Messages'] },
  ],
};

// ────────────────────────────────────────────────
// STAFF  (executed / executem)
// ────────────────────────────────────────────────
const executed = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'updates',  label: 'Updates',  icon: 'bell',     tabs: ['Periodical', 'South Yarra', 'Ticket'] },
        { id: 'calendar', label: 'Calendar', icon: 'calendar', tabs: ['Periodical', 'South Yarra', 'Ticket'] },
      ],
    },
    {
      id: 'personal', label: 'Account', icon: 'users',
      pages: [
        onboardingPagesDesktop,
        { id: 'account-page', label: 'Personal', icon: 'user', tabs: ['Money', 'User Details', 'Password', 'Resignation'] },
      ],
    },
    casualsAvailabilityDesktop,
  ],
};

const executem = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'update',   label: 'Update',   icon: 'bell',     tabs: ['Periodical', 'South Yarra', 'Ticket'] },
        { id: 'calendar', label: 'Calendar', icon: 'calendar', tabs: ['Periodical', 'South Yarra', 'Ticket'] },
      ],
    },
    accountMobile,
    casualsAvailabilityMobile,
  ],
};

// ────────────────────────────────────────────────
// SUPERVISOR  (supervisord / supervisorm)
// ────────────────────────────────────────────────
const supervisord = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'add',          label: 'Add',          icon: 'plus',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'Manage Clients'] },
        { id: 'updates',      label: 'Updates',      icon: 'bell',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket', 'TestNTag'] },
        { id: 'calendar',     label: 'Calendar',     icon: 'calendar', tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket'] },
        { id: 'recruitment',  label: 'Recruitment',  icon: 'users',    tabs: ['Current', 'Active', 'Non Active'] },
        { id: 'staff-forms',  label: 'Staff Forms',  icon: 'doc',      tabs: ['Male Uniform', 'Female Uniform', 'Record Meeting', 'Under Performance', 'Improvement Plan', 'Vendor'] },
      ],
    },
    {
      id: 'admin', label: 'Admin', icon: 'users',
      pages: [
        { id: 'dashboard', label: 'Dashboard', icon: 'users', tabs: ['Main Dashboard', 'Final Activation', 'Onboarding', 'Replacement'] },
      ],
    },
    casualsResponsesDesktop,
    accountEntryDesktop,
  ],
};

const supervisorm = {
  entries: [
    {
      id: 'leave', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'add',       label: 'Add',    icon: 'plus', tabs: ['Leave', 'Replacement', 'Extrawork'] },
        { id: 'addclient', label: 'Client', icon: 'bell', tabs: ['Periodical'] },
      ],
    },
    {
      id: 'clients', label: 'Update', icon: 'users',
      pages: [
        { id: 'updateleavem',  label: 'Leave',  icon: 'plus', tabs: ['Leave', 'Replacement', 'Extrawork'] },
        { id: 'updateclientm', label: 'Client', icon: 'bell', tabs: ['Periodical', 'South Yarra', 'Ticket'] },
      ],
    },
    casualsResponsesMobile,
    {
      id: 'calendars', label: 'Calendar', icon: 'calendar',
      pages: [
        { id: 'leave',  label: 'Leave',  icon: 'plus',  tabs: ['Leave', 'Replacement', 'Extrawork'] },
        { id: 'client', label: 'Client', icon: 'users', tabs: ['Periodical', 'South Yarra', 'Ticket'] },
      ],
    },
    {
      id: 'compliances', label: 'Compliance', icon: 'edit',
      pages: [
        { id: 'compliance-page', label: 'Compliance', icon: 'edit', tabs: ['TestNTag'] },
      ],
    },
    {
      id: 'recruitment', label: 'Recruitment', icon: 'users',
      pages: [
        { id: 'recruitment-page', label: 'Recruitment', icon: 'users', tabs: ['Current', 'Active', 'Non Active'] },
      ],
    },
    accountMobile,
  ],
};

// ────────────────────────────────────────────────
// ADMIN
// ────────────────────────────────────────────────
const admind = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'add',          label: 'Add',          icon: 'plus',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical'] },
        { id: 'updates',      label: 'Updates',      icon: 'bell',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket', 'TestNTag'] },
        { id: 'calendar',     label: 'Calendar',     icon: 'calendar', tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket'] },
        { id: 'recruitment',  label: 'Recruitment',  icon: 'users',    tabs: ['Current', 'Active', 'Non Active'] },
        { id: 'staff-forms',  label: 'Staff Forms',  icon: 'doc',      tabs: ['Male Uniform', 'Female Uniform', 'Record Meeting', 'Under Performance', 'Improvement Plan', 'Vendor'] },
      ],
    },
    {
      id: 'admin', label: 'Admin', icon: 'users',
      pages: [
        { id: 'dashboard',  label: 'Dashboard',        icon: 'users', tabs: ['Main Dashboard', 'Replacement'] },
        { id: 'database',   label: 'Database',         icon: 'users', tabs: ['Final Activation', 'Manage Users', 'Users Compliance', 'Manage Clients'] },
        { id: 'onboarding', label: 'Onboarding Staff', icon: 'plus',  tabs: ['Create New User', 'Onboarding', 'Final Activation'] },
      ],
    },
    casualsResponsesDesktop,
    accountEntryDesktop,
  ],
};

// ────────────────────────────────────────────────
// MANAGEMENT
// ────────────────────────────────────────────────
const managementd = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'add',          label: 'Add',          icon: 'plus',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'Manage Clients'] },
        { id: 'updates',      label: 'Updates',      icon: 'bell',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket', 'TestNTag'] },
        { id: 'calendar',     label: 'Calendar',     icon: 'calendar', tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket'] },
        { id: 'recruitment',  label: 'Recruitment',  icon: 'users',    tabs: ['Current', 'Active', 'Non Active'] },
        { id: 'staff-forms',  label: 'Staff Forms',  icon: 'doc',      tabs: ['Male Uniform', 'Female Uniform', 'Record Meeting', 'Under Performance', 'Improvement Plan', 'Vendor'] },
      ],
    },
    {
      id: 'admin', label: 'Admin', icon: 'users',
      pages: [
        { id: 'dashboard',   label: 'Dashboard',              icon: 'users', tabs: ['Main Dashboard', 'Replacement'] },
        { id: 'database',    label: 'Database',               icon: 'users', tabs: ['Final Activation', 'Manage Users', 'Users Compliance', 'Manage Clients'] },
        { id: 'onboarding1', label: 'Onboarding Staff',       icon: 'plus',  tabs: ['Create New User', 'Onboarding', 'Final Activation'] },
        { id: 'employee1',   label: 'Employee Payroll',       icon: 'users', tabs: ['Create Payslips', 'Send Emails', 'Employee Payments', 'Expenses Overview'] },
        { id: 'subbie1',     label: 'Subcontractor Payments', icon: 'users', tabs: ['Create Po Numbers', 'Send Po Emails', 'Subbie Payments', 'Expenses Overview'] },
      ],
    },
    casualsResponsesDesktop,
    accountEntryDesktop,
  ],
};

// ────────────────────────────────────────────────
// IT
// ────────────────────────────────────────────────
const itworkd = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'add',          label: 'Add',          icon: 'plus',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical'] },
        { id: 'updates',      label: 'Updates',      icon: 'bell',     tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket', 'TestNTag'] },
        { id: 'calendar',     label: 'Calendar',     icon: 'calendar', tabs: ['Leave', 'Replacement', 'Extrawork', 'Periodical', 'South Yarra', 'Ticket'] },
        { id: 'recruitment',  label: 'Recruitment',  icon: 'users',    tabs: ['Current', 'Active', 'Non Active'] },
        { id: 'staff-forms',  label: 'Staff Forms',  icon: 'doc',      tabs: ['Male Uniform', 'Female Uniform', 'Record Meeting', 'Under Performance', 'Improvement Plan', 'Vendor'] },
      ],
    },
    {
      id: 'admin', label: 'Admin', icon: 'users',
      pages: [
        { id: 'dashboard',   label: 'Dashboard',              icon: 'users', tabs: ['Main Dashboard', 'Replacement'] },
        { id: 'database',    label: 'Database',               icon: 'users', tabs: ['Final Activation', 'Manage Users', 'Users Compliance', 'Manage Clients'] },
        { id: 'onboarding2', label: 'Onboarding Staff',       icon: 'plus',  tabs: ['Create New User', 'Onboarding', 'Final Activation'] },
        { id: 'employee1',   label: 'Employee Payroll',       icon: 'users', tabs: ['Create Payslips', 'Send Emails', 'Employee Payments', 'Expenses Overview'] },
        { id: 'subbie1',     label: 'Subcontractor Payments', icon: 'users', tabs: ['Create Po Numbers', 'Send Po Emails', 'Subbie Payments', 'Expenses Overview'] },
      ],
    },
    casualsResponsesDesktop,
    {
      id: 'itdata', label: 'IT Data', icon: 'users',
      pages: [
        { id: 'itworkflow', label: 'IT Workflow', icon: 'users', tabs: ['Generate Password', 'Migrate Payslips', 'Bulk Hash Users'] },
      ],
    },
    accountEntryDesktop,
  ],
};

// ────────────────────────────────────────────────
// IGLU SOUTH YARRA  (iglud / iglum)
// Same shape as Staff — Workflow scoped to South Yarra + Ticket,
// Account reuses the shared desktop/mobile entries.
// ────────────────────────────────────────────────
const iglud = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
         { id: 'add',          label: 'Add',          icon: 'plus',     tabs: ['New Form', 'Bulk Upload', 'New Ticket'] },
        { id: 'updates',      label: 'Updates',      icon: 'bell',     tabs: ['Departure', 'Tickets'] },
        { id: 'calendar',     label: 'Calendar',     icon: 'calendar', tabs: ['South Yarra', 'Tickets'] },
        { id: 'personal',  label: 'Account',  icon: 'users',    tabs: ['Password'] },
      ],
    },
    
  ],
};

const iglum = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'addm',          label: 'Add',          icon: 'plus',     tabs: ['New Form', 'Bulk Upload', 'New Ticket'] },
        { id: 'updatem',  label: 'Update',  icon: 'users',    tabs: ['Update Departure','Update Ticket','Password'] },
      ],
    },
    
  ],
};


const clientd = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'addcd',          label: 'Add',          icon: 'plus',     tabs: ['New Ticket'] },
        { id: 'updatescd',      label: 'Updates',      icon: 'bell',     tabs: ['Update Tickets'] },
        { id: 'calendarcd',     label: 'Calendar',     icon: 'calendar', tabs: [ 'Tickets'] },
        { id: 'personalcd',  label: 'Account',  icon: 'users',    tabs: ['Password'] },
      ],
    },
  ],
};
 
const clientm = {
  entries: [
    {
      id: 'workflow', label: 'Workflow', icon: 'plus',
      pages: [
        { id: 'addm',          label: 'Add',          icon: 'plus',     tabs: ['New Ticket','Update Tickets','Calendar'] },
        { id: 'accountm',  label: 'Account',  icon: 'users',    tabs: ['Password'] },
      ],
    },
   
  ],
};


// Mobile for Management / Admin / IT mirrors Supervisor mobile for now
const managementm = supervisorm;

// ────────────────────────────────────────────────
// EXPORT — keyed by navSections ID
// ────────────────────────────────────────────────
export const accessMap = {
  // Staff
  executed,
  executem,

  // Supervisor (Operations)
  supervisord,
  supervisorm,

  // Management / Admin / IT
  managementd,
  managementm,
  admind,
  adminm: managementm,
  itd:    itworkd,
  itm:    managementm,

  // IGLU South Yarra
  iglud,
  iglum,

  clientd,
  clientm,

};

export default accessMap;